'use strict';

module.exports = require('./es2015');



// WEBPACK FOOTER //
// ./node_modules/es-abstract/es6.js